<template>
  <v-container
    v-if="authenticationMixin.checkedLogin"
    class="content content-with-nav pa-0"
    fluid
  >
    <!-- Hero section -->
    <page-hero
      title="Aanspreking"
      intro="Samen met u werken wij een persoonlijke uitvaart uit. Dit doen wij op basis van de door u aangeleverde informatie. Hier staat u dan uiteraard nog vrij om wijzigingen aan te brengen waar gewenst."
    />

    <!-- Content -->
    <v-row justify="center">
      <v-col
        class="center"
        cols="12"
        md="8"
        lg="6"
      >
        <p class="aanspreking-info">
          Hoe werd de overledene aangesproken:
        </p>
        <ul class="aanspreking-list">
          <li>in de familie (pa, ma, bompa, bomma, ...)</li>
          <li>door anderen (nonkel ..., tante ..., ...)</li>
        </ul>
        <p class="aanspreking-info mt-4">
          Welke aanspreking wordt het best gebruikt doorheen de plechtigheid?
        </p>
        <v-textarea
          v-model="algemeneInfo.aanspreking"
          auto-grow
          base-color="primary"
          bg-color="white"
          color="primary"
          density="compact"
          rows="3"
          variant="outlined"
        />
        <div class="d-flex justify-end">
          <v-btn
            color="primary"
            rounded
            @click="SaveGeneralInfo"
          >
            <v-icon
              class="mr-1"
              size="18"
            >
              mdi-content-save-outline
            </v-icon>
            Opslaan
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <!-- Navigation -->
    <div class="samenstellen-nav">
      <div class="samenstellen-nav-inner">
        <v-btn
          v-if="samenstellenNavigation_PreviousItem"
          color="primary"
          :disabled="samenstellenNavigation_PreviousItem.disabled"
          rounded
          variant="text"
          @click="samenstellenNavigation_GoToPrevious"
        >
          <v-icon start>
            mdi-chevron-left
          </v-icon>
          {{ samenstellenNavigation_PreviousItem.title }}
        </v-btn>
        <span v-else />
        <v-btn
          v-if="samenstellenNavigation_NextItem"
          color="primary"
          :disabled="samenstellenNavigation_NextItem.disabled"
          rounded
          variant="text"
          @click="samenstellenNavigation_GoToNext"
        >
          {{ samenstellenNavigation_NextItem.title }}
          <v-icon end>
            mdi-chevron-right
          </v-icon>
        </v-btn>
        <span v-else />
      </div>
    </div>
  </v-container>
</template>

<script>
import PageHero from '@/components/PageHero.vue'
import authenticationMixin from '@/mixins/authenticationMixin'
import commonMixin from '@/mixins/commonMixin'
import errorMixin from '@/mixins/errorMixin'
import samenstellenNavigationMixin from '@/mixins/samenstellenNavigationMixin'
import klantService from '@/services/klantService'

export default {
  name: 'AansprekingComponent',
  components: { PageHero },
  mixins: [
    authenticationMixin,
    commonMixin,
    errorMixin,
    samenstellenNavigationMixin
  ],
  data () {
    return {
      algemeneInfo: {}
    }
  },
  mounted () {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    this.AuthenticationMixin_CheckIfLoggedIn()
    this.$store.state.headers.samenstellen = true
    klantService.Init(this)
    this.GetUitvaartDraaiboek()
  },
  beforeUnmount () {
    this.$store.state.headers.samenstellen = false
  },
  methods: {
    async GetUitvaartDraaiboek () {
      this.CommonMixin_Load(this.$options.name, true)
      const resp = await klantService.GetUitvaartDraaiboek()

      if (resp && (resp.data || resp.data !== '')) {
        this.algemeneInfo = resp.data
      }

      this.CommonMixin_Load(this.$options.name, false)
    },
    async SaveGeneralInfo () {
      this.CommonMixin_Load(this.$options.name, true)
      await klantService.SaveUitvaartDraaiboek(this.algemeneInfo)
      this.CommonMixin_Load(this.$options.name, false)
    }
  }
}
</script>

<style scoped>
.aanspreking-info {
  font-size: 15px;
  color: #424E58;
  padding: 0;
  margin: 0 0 4px 0;
}

.aanspreking-list {
  font-size: 15px;
  color: #6b6b6b;
  padding-left: 20px;
  margin: 0;
}

.aanspreking-list li {
  margin-bottom: 2px;
}
</style>
